var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClosePane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_23_50",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_23_50",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACI0lEQVR4nO3cz07UUBhA8QMRBww+gax9An0Zn0HlRdgYQ8LOxMSF4T38s1IjuvEdlMCswUVxM5lOb9t7v16n55d0Reej96QpmelQkCRJkiRJmq994Bj4DCyB25ltS+AT8BJYjGzZ6gj4VsFia9m+3jXJah8jt8XOemYfV7CoWrcXKQF3U3YCniXuN0dJbXYSh10Dh8OPZastgYddO6WGvh35+ihtx1laZ4fUS4dGMnQQQwcxdBBDBzF0EEMHMXQQQwcxdBBDBzF0EEMHMXQQQwcxdBBDB6kl9FPgAvgNnAD3pj2c6bTdAc7lx8rc9wyLPdWd8GxK/4KbNbOHxDb0wPnnwF6GOYbumN83tqEHzu8be3ahHwCnwGXGxaRcs2cX+qzQgt4MPM7JQ5f4ptIuzdekDhJn9/UY+NXys6xnVw9+U6kWJULfAG8LzIXm0tF2Nm+FvtemA+A18GfDa/1j2GMBpef/285Je5do6IHz+0TummPoDfP7RN40x9B3/FCpYwG5XKzM9WPSQr/gCfCd5o3OK4Z/8F9taP+HJQ/fGdbC0EEMHcTQQQwdxNBBDB3E0EEMHcTQQQwdxNBBDB3E0EEMHcTQQQwdJPWW0ZL1j2Ob6o5GTa5Sdko9o3+OOJBtl9QmNfS7EQey7bK2WdA88HSqu8y1bl+A+yO6rnWEsVcjPxpVdIMFzdNlP9I8r3TqxUZv18AH4DkFzmRJkiRJkqT/xV8Jrmj05M7FWQAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePane);
export default __webpack_public_path__ + "static/media/close-pane.4fa088db9b47c858717215c33d17d1ae.svg";
export { ForwardRef as ReactComponent };